<template>
  <SkeletonPulse>
    <div class="resume-card-skeleton">
      <div class="resume-card-skeleton__mobile-date mq-mobile-only">
        <SkeletonShape width="116px" height="14px" />
      </div>
      <div class="resume-card-skeleton__aside">
        <SkeletonShape width="50px" height="50px" border-radius="50px" />
      </div>
      <div class="resume-card-skeleton__main">
        <div class="resume-card-skeleton__date mq-not-mobile">
          <SkeletonShape width="115px" height="12px" />
        </div>
        <div class="resume-card-skeleton__content mq-not-mobile">
          <SkeletonShape width="283px" height="16px" />
          <SkeletonShape width="194px" height="15px" />
          <SkeletonShape width="431px" height="15px" />
          <SkeletonShape width="105px" height="15px" />
          <SkeletonShape width="431px" height="15px" />
        </div>
        <div class="resume-card-skeleton__mobile-content mq-mobile-only">
          <SkeletonShape width="275px" height="20px" />
          <SkeletonShape width="166px" height="18px" />
          <SkeletonShape width="275px" height="16px" />
          <SkeletonShape width="393px" height="18px" />
          <SkeletonShape width="120px" height="16px" />
          <SkeletonShape width="205px" height="16px" />
        </div>
      </div>
    </div>
  </SkeletonPulse>
</template>

<script>
  import SkeletonPulse from "src/components/SkeletonPulse/SkeletonPulse.vue";
  import SkeletonShape from "src/components/SkeletonShape/SkeletonShape.vue";

  export default {
    name: 'ResumeCardSkeleton',
    components: { SkeletonPulse, SkeletonShape },
  }
</script>